/* React */
import React, { useState } from "react";

/* Ionic */
import { IonSearchbar } from "@ionic/react";
import { close, search } from "ionicons/icons";

/* React-Redux */
import { useDispatch, useSelector } from "react-redux";
import { RootState } from "src/redux/store";
import { setSearchTerm } from "src/redux/features/search-term/searchTermSlice";

/* Components */
import PrimaryFabButton from "src/components/shared/buttons/primary-fab-button/PrimaryFabButton";

/* Stylesheet */
import styles from "./Searchbar.module.scss";

/* Interfaces */
interface SearchbarProps {
  disabled?: boolean;
}

const Searchbar: React.FC<SearchbarProps> = ({
  disabled,
}) => {
  const dispatch = useDispatch();

  const [showSearchbar, setShowSearchbar] =
    useState<boolean>(false);

  const searchTermState = useSelector(
    (state: RootState) => state.searchTerm
  );

  const { searchTerm } = searchTermState;

  return (
    <>
      <PrimaryFabButton
        className={"small primary"}
        ariaLabel={"Search"}
        icon={showSearchbar ? close : search}
        disabled={disabled}
        onClick={() => setShowSearchbar(!showSearchbar)}
      />
      {showSearchbar ? (
        <IonSearchbar
          className={styles.searchbar}
          value={searchTerm}
          debounce={300}
          onIonInput={(e) => {
            dispatch(setSearchTerm(e.target.value));
          }}
        />
      ) : undefined}
    </>
  );
};

export default Searchbar;
